import { useEffect } from 'react'
import * as Sentry from '@sentry/tanstackstart-react'
import { createFileRoute, type ErrorComponentProps } from '@tanstack/react-router'
import AuthGuard from '../components/AuthGuard'
import { RulesListClient } from '../components/RulesListClient'
import { prefetchPolicies } from '../lib/route-prefetch'

function RulesError({ error }: ErrorComponentProps) {
  useEffect(() => { Sentry.captureException(error) }, [error])
  return (
    <div className="p-8 text-center text-gray-600">
      Failed to load rules.{' '}
      <button onClick={() => window.location.reload()} className="text-brand underline">
        Retry
      </button>
    </div>
  )
}

export const Route = createFileRoute('/rules/')({
  head: () => ({
    meta: [{ title: 'Rules | Unbreakable' }],
  }),
  beforeLoad: ({ context }) => {
    prefetchPolicies(context.queryClient)
  },
  errorComponent: RulesError,
  component: RulesPage,
})

function RulesPage() {
  return (
    <AuthGuard>
      <RulesListClient />
    </AuthGuard>
  )
}
